import React from 'react';
import { Translations } from '../i18n/translations';

export type SystemStateKind = 'ok' | 'degraded' | 'down';

export interface SystemState {
  kind: SystemStateKind;
  note: string;
  detail?: string;
}

interface SystemStatusProps {
  state: SystemState;
  t: Translations;
}

// Tiny status pill: coloured dot + a very short label. Hover for detail.
// Deliberately framed as "system" (feeds + analysis + retries) rather than
// "AI" so the user reads it as the engine's overall health, not just the
// AI sidecar.
export const SystemStatus: React.FC<SystemStatusProps> = ({ state, t }) => {
  const dotClass =
    state.kind === 'ok'
      ? 'bg-green-500'
      : state.kind === 'degraded'
        ? 'bg-amber-500'
        : 'bg-red-500';
  const labelClass =
    state.kind === 'down'
      ? 'text-red-700 dark:text-red-400'
      : 'text-gray-600 dark:text-gray-400';
  const title = state.detail ? `${t.systemStatusLabel}: ${state.note} — ${state.detail}` : `${t.systemStatusLabel}: ${state.note}`;
  return (
    <div
      className="inline-flex items-center gap-1.5 px-1 sm:px-2"
      role="status"
      aria-label={title}
      title={title}
    >
      <span
        className={`inline-block w-2 h-2 rounded-full ${dotClass}`}
        aria-hidden="true"
      />
      <span className={`hidden md:inline text-xs font-medium ${labelClass}`}>
        {state.note}
      </span>
    </div>
  );
};
